import { Typography, styled } from '@mui/material';

export const ContentText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: '1.625rem',
  color: theme.palette.primary.main,
}));
